import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Accordion, AccordionCollapseAnimated, AccordionItem, AccordionToggle, } from '@awaze/design-system.components.accordion';
import { BaseGrid, BaseGridItem, } from '@awaze/design-system.components.base-grid';
import { ListItem } from '@awaze/design-system.components.list-item';
import { breakpoints, createIdFromString, useWindowWidth, } from '@awaze/design-system.utils.react';
import { StyledFooterAnchor } from './footer.styles';
const StyledHeading = styled.span `
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
`;
const StyledAccordionItem = styled(AccordionItem) `
  ${({ theme }) => css `
      & {
        border-top: none;
      }
      &:last-child {
        border-bottom: 1px solid ${theme.ColorWhiteOpacity20};
      }
      @media (min-width: ${breakpoints[0]}px) {
        &:last-child {
          border-bottom: 0;
        }
      }
    `}
`;
export const FooterMenu = ({ menu, theme }) => {
    const width = useWindowWidth();
    const isMobile = width < breakpoints[0];
    function getLinks() {
        return menu.menuItems.map((menuItem, menuItemIdx) => {
            const headingId = createIdFromString(menuItem.link.displayText);
            const anchors = menuItem.subMenu.map((anchor, anchorIdx) => (_jsx(ListItem, { children: _jsx(StyledFooterAnchor, { href: anchor.link.href, title: anchor.link.displayText, target: anchor.link.openInNew ? '_blank' : '_self', children: anchor.link.displayText }) }, `${headingId}-${anchorIdx}`)));
            return (_jsx(BaseGridItem, { columns: [12, 3], children: _jsxs(StyledAccordionItem, { children: [_jsx(AccordionToggle, { children: _jsx(StyledHeading, { children: menuItem.link.displayText }) }), _jsx(AccordionCollapseAnimated, { children: _jsx("ul", { children: anchors }) })] }) }, `${headingId}-${menuItemIdx}`));
        });
    }
    return (_jsx(Accordion, { disabled: !isMobile, darkTheme: theme ? theme.accordion === 'dark' : false, children: _jsx(BaseGrid, { flush: true, children: getLinks() }) }));
};
//# sourceMappingURL=footer-menu.js.map